import React from 'react';

import { DIRECTORIES } from '@lumapps/directories/keys';
import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiApps } from '@lumapps/lumx/icons';
import { useTranslate } from '@lumapps/translations';

import { admin } from '../../routes';

export interface ModuleSideNavigationProps extends Partial<SideNavigationItemProps> {
    isAllowed: boolean;
}

const ModuleSideNavigation = (props: Partial<ModuleSideNavigationProps>) => {
    const { isAllowed, ...restOfProps } = props;

    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem {...restOfProps} route={admin()} label={translateKey(DIRECTORIES.MODULES)} icon={mdiApps} />
    );
};

ModuleSideNavigation.displayName = 'SideNavigationItem';

export { ModuleSideNavigation };
